import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import "../../styles/Asummery.css";
import { useNavigate } from "react-router-dom";


function SAsecuritysum() {
  const [pivotData, setPivotData] = useState([]);
  const [emails, setEmails] = useState([]);
  const navigate = useNavigate();  
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");  

  useEffect(() => {
  async function fetchData() {
    // 🔹 fetch users with roles
    const usersSnap = await getDocs(collection(db, "users"));
    const usersData = usersSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // 🔹 exclude "security" role emails
    const allowedUsers = usersData.filter((u) => u.role === "security" );
    const allowedEmails = allowedUsers.map((u) => u.email);

    
    // 🔹 fetch reviews
         let reviewList = (await getDocs(collection(db, "reviews")))
                 .docs.map((doc) => ({ id: doc.id, ...doc.data() }))

    // 🔹 filter by selected date range
    if (startDate) {
      const start = new Date(startDate);
      reviewList = reviewList.filter(r => r.createdAt?.toDate() >= start);
    }
    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59); // include full day
      reviewList = reviewList.filter(r => r.createdAt?.toDate() <= end);
    }

        // 🔹 collect unique hotels
        const uniqueHotels = [
        ...new Set(reviewList.map((r) => r.hotelName || "Unknown Hotel")),
        ];

        // 🔹 build pivot tables grouped by hotel
        const tablesByHotel = uniqueHotels.map((hotel) => {
        const hotelReviews = reviewList.filter(
            (r) => (r.hotelName || "Unknown Hotel") === hotel
        );

        // 🔹 collect unique points for this hotel (only starting with "SP", case-insensitive)
        const uniquePoints = [
          ...new Set(
            hotelReviews
              .map((r) => r.qrData || "Unknown Point")
              .filter((point) => point.toLowerCase().startsWith("s p"))
          ),
        ];

        const table = uniquePoints.map((point) => {
            const row = { point };
            allowedEmails.forEach((email) => {
            const userReviews = hotelReviews.filter(
                (r) =>
                (r.userEmail || "Unknown") === email &&
                (r.qrData || "Unknown Point") === point
            );
            const count = userReviews.length;

            let lastDate = "-";
            if (userReviews.length > 0) {
                const latestReview = userReviews.reduce((latest, current) => {
                const latestTime =
                    latest.createdAt?.toDate?.()?.getTime?.() || 0;
                const currentTime =
                    current.createdAt?.toDate?.()?.getTime?.() || 0;
                return currentTime > latestTime ? current : latest;
                });
                 // ✅ Format directly as "DD Mon" (no year)
                lastDate = latestReview.createdAt?.toDate
                  ? latestReview.createdAt.toDate().toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short", // e.g. "30 Aug"
                    })
                  : "-";
            }

           row[email] = count > 0 ? (
          <>
            {count}
            <br />
            ({lastDate})
          </>
        ) : "-";
        
            });
            return row;
        });

        return { hotel, table };
        });

        setEmails(allowedEmails);
        setPivotData(tablesByHotel);

  }

  fetchData();
}, [startDate, endDate]);

  return (

    <div className="summary-container">

    <button onClick={() => navigate("/superadmin")} className="history-btn">
       Home
      </button>

      <h2 style={{color:"black"}}>📊 Security User Points Summary by Hotel</h2>

       <div className="date-filter">
        <label>
          Start Date: 
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>
        <label>
          End Date: 
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>
      </div>

        {pivotData.map((hotelData, idx) => (
        <div key={idx} className="hotel-section">
            <h3>🏨 {hotelData.hotel}</h3>
            <div className="table">
            <table className="summary-table">
                <thead>
                <tr>
                    <th>Points</th>
                    {emails.map((email, idx2) => (
                    <th key={idx2}>{email.split("@")[0]}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {hotelData.table.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                    <td>{row.point}</td>
                    {emails.map((email, idx3) => (
                        <td key={idx3}>{row[email]}</td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
        </div>
        ))}

    </div>
  );
}

export default SAsecuritysum;
